module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1950.4a793458.svg";